//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ManholeCoverDrawer from "./modules/ManholeCoverDrawer";
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import { getAction } from '@/api/manage';
export default {
  name: "ManholeCoverList",
  mixins: [JeecgListMixin],
  components: {
    ManholeCoverDrawer: ManholeCoverDrawer
  },
  data: function data() {
    return {
      pagePath: '/sys/manhole/cover',
      visible: false,
      pageTitle: '窨井',
      title: '',
      pipeSystemId: "",
      pointList: "",
      // 表头
      columns: [{
        dataIndex: 'mn',
        colName: 'mn',
        title: '编号',
        align: "center",
        sorter: true
      }, {
        dataIndex: 'title',
        colName: 'title',
        title: '名称',
        align: "center",
        sorter: true
      }, {
        dataIndex: 'category_dictText',
        colName: 'category',
        title: '类型',
        align: "center",
        sorter: true
      }, {
        dataIndex: 'coordinate',
        colName: 'coordinate',
        title: '坐标',
        align: "center",
        sorter: true
      }, {
        dataIndex: 'addr',
        colName: 'addr',
        title: '地址',
        align: "center",
        sorter: true
      }, {
        dataIndex: 'status_dictText',
        colName: 'status',
        title: '状态',
        align: "center",
        sorter: true
      }, {
        dataIndex: 'sort',
        colName: 'sort',
        title: '排序号',
        align: "center",
        sorter: true
      }, {
        title: '操作',
        dataIndex: 'action',
        align: "center",
        width: 120,
        scopedSlots: {
          customRender: 'action'
        }
      }]
    };
  },
  created: function created() {
    this.$store.state.projectCode == 'meitang' ? this.pageTitle = '化粪池' : '窨井';
  },
  computed: {},
  methods: {
    refresh: function refresh(pipeSystemId, pointList) {
      this.pipeSystemId = pipeSystemId;
      this.pointList = pointList;
      this.queryParam.pipeSystemId = pipeSystemId;
      this.visible = true;
      this.loadData();
    },
    initTableData: function initTableData(arg) {
      var _this = this;

      if (this.queryParam.pipeSystemId == null) return;

      if (arg === 1) {
        this.ipagination.current = 1;
      }

      var params = this.getQueryParams(); //查询条件

      this.loading = true;
      getAction(this.url && this.url.list ? this.url.list : this.pagePath, params).then(function (res) {
        if (res.success) {
          var paramList = [];

          for (var i = 0; i < res.result.records.length; i++) {
            var param = res.result.records[i];
            param.key = param.code;
            param.editable = false;
            paramList.push(param);
          }

          _this.dataSource = paramList;
          _this.ipagination.total = res.result.total;
        }

        if (res.code === 510) {
          _this.$message_custom(res.message, 'warning');
        }

        _this.loading = false;
      });
    },
    handleAdd_: function handleAdd_() {
      this.handleAdd();
      this.$refs.modalForm.add(this.pipeSystemId, this.pointList);
    },
    handleEdit_: function handleEdit_(record, pointList) {
      this.handleEdit(record);
      this.$refs.modalForm.edit(record, this.pipeSystemId, this.pointList);
    },
    modalFormOk: function modalFormOk() {
      this.queryParam = {
        pipeSystemId: this.queryParam.pipeSystemId
      }; // 新增/修改 成功时，重载列表

      this.loadData();
    },
    searchReset: function searchReset() {
      this.queryParam = {
        pipeSystemId: this.queryParam.pipeSystemId
      };
      this.loadData(1);
    },
    close: function close() {
      this.$emit('close');
      this.visible = false;
    }
  }
};